export default __webpack_public_path__ + "static/med-imx-7b71c81e6b6bafe8e11e38830675b894.png";